import Logo from './Logo'

export default function NavBar() {
  return (
    <nav className="w-full flex justify-between items-center px-6 lg:px-32 py-3 shadow-md shadow-black/10 ">
        <a href="/"><Logo/></a>
        <a href='https://pigeonultra.com/#contact-us' target={'_blank'} rel="noreferrer" className="py-1 px-3 bg-black text-white rounded">Join PigeonUltra &trade;</a>
    </nav>
  )
}
